import { makeStyles, Box } from '@material-ui/core'
import React from 'react'
import { DateTimeInput } from './base-datepicker'

const useStyles = makeStyles({
  pickerContainer: {
    width: '100%',
    backgroundColor: '#E8E8E8',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    marginTop: 8,
    '&:hover': {
      backgroundColor: '#DEDEDE',
    },
  },
})

export const DatetimePicker = (props: any) => {
  const classes = useStyles()
  return (
    <Box>
      <DateTimeInput
        {...props}
        options={{
          format: 'dd/MM/yyyy HH:mm:ss',
          ampm: false,
          cancelLabel: 'cancelar',
          okLabel: 'confirmar',
        }}
        className={classes.pickerContainer}
      />
    </Box>
  )
}
